<section class="assigned-drivers-panel">
  <h3 class="panel-title">
    {{ 'modals.add_assignament.assigned_drivers.title' | translate }}
  </h3>
  <p class="panel-subtitle">
    {{ 'modals.add_assignament.assigned_drivers.description' | translate }}
  </p>

  <div class="summary-card">
    <div class="summary-content">
      <h4 class="summary-title">
        {{ 'modals.add_assignament.assigned_drivers.label' | translate }}
      </h4>

      <ng-container *ngIf="!isLoadingDrivers">
        <p class="summary-state" *ngIf="hasAssignedDrivers; else emptyState">
          {{
            'modals.add_assignament.assigned_drivers.all_included'
              | translate : { included: includedDrivers, total: totalDrivers }
          }}
        </p>
        <ng-template #emptyState>
          <p class="summary-state empty">
            {{ 'modals.add_assignament.assigned_drivers.none_assigned' | translate }}
          </p>
        </ng-template>
      </ng-container>
    </div>

    <button type="button" class="view-all-btn" [disabled]="isLoadingDrivers" (click)="onViewAll()">
      <span class="view-all-loading" *ngIf="isLoadingDrivers; else viewAllLabel">
        <tui-loader size="s" class="view-all-loader"></tui-loader>
        {{ 'modals.add_assignament.assigned_drivers.searching_drivers' | translate }}
      </span>

      <ng-template #viewAllLabel>
        {{ 'modals.add_assignament.assigned_drivers.view_all' | translate }}
      </ng-template>
    </button>
  </div>
</section>
